import React, { lazy, Suspense, useEffect } from 'react';
import {
  RenderRoutesRecursively,
  protectedRoute,
  adminProtectedRoute,
} from 'AppRoutes';
import PropTypes from 'prop-types';
import MainLayout from 'modules/MainLayout/MainLayout';
import MainLayoutBeforeLogin from 'modules/MainLayoutBeforeLogin/MainLayoutBeforeLogin';
import Logout from 'modules/public/Logout/Logout';
import Loading from 'assets/images/loading.png';
import PropertyDetailContainer from 'modules/private/PropertyProfileContainer/PropertyProfileContainer';
// import { TaskPageTask } from "component/TaskPagePopUp/TaskPageTask";
import { TaskPageNoteandFeedback } from 'component/TaskPageNoteandFeedback/TaskPageNoteandFeedback';
import Login from 'modules/public/LoginPage/LoginPage';
import Market from 'component/BuyersMarketplace/Market';
import {
  Redirect,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { USER_TYPE } from 'constant/app.config';
import PageNotFoundFile from 'component/PageNotFound/PageNotFoundFile';
import InvitePage from 'modules/private/Invite/InvitePage';
import { ADMIN_PERMISSIONS } from 'constant/admin.config';
import { AdminLoadingState } from 'component/Admin/AdminStateViews';
// const Login = lazy(() => import("modules/public/LoginPage/LoginPage"));
const SignUp = lazy(() => import('modules/public/SignUp/SignUp'));

// Admin layer — code split so it never lands in the main app bundle.
const AdminLayout = lazy(() => import('modules/admin/AdminLayout/AdminLayout'));
const AdminDashboard = lazy(() =>
  import('modules/admin/Dashboard/AdminDashboard')
);
const AdminUsers = lazy(() => import('modules/admin/Users/AdminUsers'));
const AdminRoles = lazy(() => import('modules/admin/Roles/AdminRoles'));
const AdminAgencies = lazy(() =>
  import('modules/admin/Agencies/AdminAgencies')
);
const AdminFeatureSets = lazy(() =>
  import('modules/admin/FeatureSets/AdminFeatureSets')
);
const AdminAnalytics = lazy(() =>
  import('modules/admin/Analytics/AdminAnalytics')
);
const AdminProfile = lazy(() => import('modules/admin/Profile/AdminProfile'));
const AdminContactInformation = lazy(() =>
  import('modules/admin/ContactInformation/AdminContactInformation')
);
const AdminAuditLog = lazy(() =>
  import('modules/admin/AuditLog/AdminAuditLog')
);
const AdminReports = lazy(() => import('modules/admin/Reports/ReportsPage'));

const DashBoard = lazy(() => import('modules/private/DashBoard/DashBoard'));
const ViewDashboardDetails = lazy(() =>
  import('modules/private/ViewDashBoardDetails/ViewDashboardDetails')
);
const ContactPage = lazy(() =>
  import('modules/private/ContactPage/ContactPage')
);
const PipelinePage = lazy(() =>
  import('modules/private/PipelineManagement/Pipelinemanagement')
);
const ProfileSetting = lazy(() =>
  import('../component/AccountMenu/ProfileSetting')
);
const Helpdesk = lazy(() => import('../component/Common/Helpdesk'));
const Insightpage = lazy(() =>
  import('../modules/private/Insights/Insightpage')
);
const BuyerDashboard = lazy(() =>
  import('modules/private/BuyerDashboard/BuyerDashboard')
);

const VendorDashboard = lazy(() =>
  import('modules/private/VendorDashboard/VendorDashboard')
);

const VendorIndividualDashboard = lazy(() =>
  import('modules/private/VendorIndividualDashboard/VendorIndividualDashboard')
);

const VendorInactiveIndividual = lazy(() =>
  import('modules/private/VendorInactiveIndividual/VendorInactiveIndividual')
);

const TaskPage = lazy(() => import('modules/private/TaskPage/TaskPage'));

const Message = lazy(() => import('modules/private/Message/Message'));

const Savedsearch = lazy(() =>
  import('modules/private/Savedsearch/Savedsearch')
);

const BuyerChats = lazy(() => import('../component/Questionaire/BuyerChats'));
const AgentChats = lazy(() => import('../component/Questionaire/AgentChat'));
const VendorChats = lazy(() => import('../component/Questionaire/VendorChat'));
const LandingPage = lazy(() =>
  import('modules/private/BuyerLandingPage/BuyerLandingPage')
);
const GalleryPage = lazy(() =>
  import('component/BuyersMarketplace/MarketGallery')
);
const BuyerSolicitorPage = lazy(() =>
  import('modules/private/BuyerSolicitor/BuyerSolicitor')
);
const Survey = lazy(() => import('modules/private/BuyerDashboard/BuyerChat'));

const data1 = localStorage.getItem('userDetail');
const userDetail = JSON.parse(data1);
const primaryUserType = userDetail?.primaryUserType;

function ForceLogout() {
  const history = useHistory();
  useEffect(() => {
    history.push('/logout');
  }, [history]);

  return null;
}
function MainLayoutWithSuspense(props) {
  const { children } = props;
  const location = useLocation();
  const history = useHistory();
  const currentPage = window.location.pathname;

  useEffect(() => {
    let accessToken = localStorage.getItem('accesstoken');
    let accessToken_val = accessToken !== 'undefined' ? accessToken : null;
    let dashboardCount = localStorage.getItem('dashboardCount');
    let dashboardCount_val =
      dashboardCount !== 'undefined' ? dashboardCount : null;
    if (accessToken_val == null) {
      if (!currentPage.includes('/share')) {
        history.push('/logout');
      }
    }
    if (
      primaryUserType == 'Buyer' &&
      dashboardCount &&
      dashboardCount_val == null
    ) {
      history.push('/logout');
    }
  }, [location.pathname]); // Logs whenever the route changes

  return (
    <MainLayout {...props}>
      <Suspense
      // fallback={
      //   <div
      //     style={{
      //       marginTop: "19%",
      //       marginLeft: "40%",
      //       height:"100vh",
      //     }}
      //   >
      //     <img alt="Logo" src={Loading} className="loaderImage" />
      //     <div style={{ paddingLeft: "10%", fontSize: "15px" }}>
      //       Loading...
      //     </div>
      //   </div>
      // }
      >
        {children}
      </Suspense>
    </MainLayout>
  );
}

function AdminLayoutWithSuspense(props) {
  const { children } = props;
  return (
    <Suspense fallback={<AdminLoadingState label="Loading admin console…" />}>
      <AdminLayout {...props}>
        <Suspense fallback={<AdminLoadingState label="Loading module…" />}>
          {children}
        </Suspense>
      </AdminLayout>
    </Suspense>
  );
}

/** Builds one protected admin route entry — keeps the config below terse. */
const adminRoute = (key, component, permission) => ({
  label: '',
  key,
  routeType: adminProtectedRoute,
  layout: AdminLayoutWithSuspense,
  component,
  permission,
  exact: true,
});

function MainLayoutWithSuspenseBeforeLogin(props) {
  const { children } = props;
  return (
    <MainLayoutBeforeLogin {...props}>
      <Suspense fallback={<div>LOADING</div>}>
        before login checkinf
        {children}
      </Suspense>
    </MainLayoutBeforeLogin>
  );
}

const routeConfig = {
  login: {
    label: 'Login',
    key: 'login',
    component: RenderRoutesRecursively,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        component: Login,
      },
    },
  },
  signup: {
    label: 'signup',
    key: 'signup',
    component: RenderRoutesRecursively,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        component: SignUp,
      },
    },
  },
  logout: {
    label: 'Logout',
    key: 'logout',
    component: RenderRoutesRecursively,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        component: Logout,
      },
    },
  },
  sharemarket: {
    label: '',
    key: 'share/:propertyId',
    component: RenderRoutesRecursively,
    layout: MainLayoutWithSuspense,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        component: Market,
      },
      gallery: {
        label: 'Gallery',
        key: 'gallery',
        exact: true,
        component: GalleryPage,
      },
    },
  },

  'reset-password': {
    label: 'Reset Password',
    key: 'reset-password',
    component: RenderRoutesRecursively,
    layout: MainLayoutWithSuspenseBeforeLogin,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        component: () => <div>reset passwr</div>,
      },
    },
  },
  BuyerLandingPage: {
    label: '',
    key: 'BuyerLandingPage',
    routeType: protectedRoute,
    component: RenderRoutesRecursively,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        routeType: protectedRoute,
        component: USER_TYPE != 'Solicitor' ? LandingPage : ForceLogout,
      },
    },
  },
  GalleryPage: {
    label: '',
    key: 'market/:propertyId/gallery',
    routeType: protectedRoute,
    component: RenderRoutesRecursively,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        routeType: protectedRoute,
        component: USER_TYPE == 'Buyer' ? GalleryPage : ForceLogout,
      },
    },
  },
  Buyersolicitor: {
    label: 'BuyerSolicitor',
    key: 'solicitor',
    routeType: protectedRoute,
    component: RenderRoutesRecursively,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        routeType: protectedRoute,
        component: USER_TYPE == 'Solicitor' ? BuyerSolicitorPage : ForceLogout,
      },
    },
  },

  /**
   * Admin layer.
   *
   * Sits alongside the existing routes rather than inside the authenticated
   * `'/'` group, so it has its own guard (`adminProtectedRoute`), its own
   * layout and no effect on any user-facing workflow. New admin modules only
   * need an entry here plus one in `constants/admin.menu.config`.
   *
   * There is no admin sign-in route: admins sign in on the common retreX
   * login page, which pushes straight to `/admin/dashboard`.
   */
  admin: {
    label: 'Admin',
    key: 'admin',
    component: RenderRoutesRecursively,
    exact: false,
    routes: {
      '/': {
        label: '',
        key: '/',
        exact: true,
        routeType: adminProtectedRoute,
        component: () => <Redirect to="/admin/dashboard" />,
      },
      dashboard: adminRoute(
        'dashboard',
        AdminDashboard,
        ADMIN_PERMISSIONS.DASHBOARD_VIEW
      ),
      users: adminRoute('users', AdminUsers, ADMIN_PERMISSIONS.USERS_VIEW),
      roles: adminRoute('roles', AdminRoles, ADMIN_PERMISSIONS.ROLES_ASSIGN),
      agencies: adminRoute(
        'agencies',
        AdminAgencies,
        ADMIN_PERMISSIONS.AGENCIES_VIEW
      ),
      featureSets: adminRoute(
        'feature-sets',
        AdminFeatureSets,
        ADMIN_PERMISSIONS.FEATURES_MANAGE
      ),
      analytics: adminRoute(
        'analytics',
        AdminAnalytics,
        ADMIN_PERMISSIONS.ANALYTICS_VIEW
      ),
      profile: adminRoute(
        'profile',
        AdminProfile,
        ADMIN_PERMISSIONS.PROFILE_VIEW
      ),
      contactInformation: adminRoute(
        'contact-information',
        AdminContactInformation,
        ADMIN_PERMISSIONS.CONTACT_MANAGE
      ),
      auditLog: adminRoute(
        'audit-log',
        AdminAuditLog,
        ADMIN_PERMISSIONS.ACTIVITY_VIEW
      ),
      reports: adminRoute(
        'reports',
        AdminReports,
        ADMIN_PERMISSIONS.REPORTS_VIEW
      ),
    },
  },

  '/': {
    label: '/',
    key: '/',
    routeType: protectedRoute,
    component: RenderRoutesRecursively,
    layout: MainLayoutWithSuspense,
    exact: false,
    routes: {
      dashboard: {
        label: 'Dashboard',
        key: 'dashboard',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component:
              primaryUserType == 'Agent'
                ? DashBoard
                : primaryUserType == 'Buyer'
                ? BuyerDashboard
                : primaryUserType == 'Vendor'
                ? VendorDashboard
                : primaryUserType == 'Solicitor'
                ? () => <Redirect to="/solicitor" />
                : ForceLogout,
          },
          'view-dashboard': {
            label: '',
            key: 'view-dashboard/:dashboardId',
            exact: true,
            routeType: protectedRoute,
            // component: ViewDashboardDetails,
            component:
              USER_TYPE == 'Agent' ? ViewDashboardDetails : ForceLogout,
            isNavigatable: false,
            showBtn: true,
            showSaveDisabled: true,
          },
          'viewactive-dashboard': {
            label: '',
            key: 'viewactive-dashboard/:dashboardId',
            routeType: protectedRoute,
            component: RenderRoutesRecursively,
            exact: false,
            routes: {
              '/': {
                label: '',
                key: '/',
                exact: true,
                routeType: protectedRoute,
                component:
                  USER_TYPE == 'Vendor'
                    ? VendorIndividualDashboard
                    : ForceLogout,
              },
            },
          },
          'viewinactive-dashboard': {
            label: '',
            key: 'viewinactive-dashboard/:dashboardId',
            routeType: protectedRoute,
            component: RenderRoutesRecursively,
            exact: false,
            routes: {
              '/': {
                label: '',
                key: '/',
                exact: true,
                routeType: protectedRoute,
                component:
                  USER_TYPE == 'Vendor'
                    ? VendorInactiveIndividual
                    : ForceLogout,
              },
            },
          },
          'property-profile': {
            label: '',
            key: 'property-profile/:propertyId',
            exact: true,
            routeType: protectedRoute,
            component: PropertyDetailContainer,
            isNavigatable: false,
            showBtn: true,
            showSaveDisabled: true,
          },
        },
      },

      Survey: {
        label: '',
        key: 'Survey',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE == 'Buyer' ? Survey : ForceLogout,
          },
        },
      },
      Buyerfeedback: {
        label: '',
        key: '/Buyerfeedback',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE == 'Buyer' ? BuyerChats : ForceLogout,
          },
        },
      },
      Agentfeedback: {
        label: '',
        key: '/Agentfeedback',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE == 'Agent' ? AgentChats : ForceLogout,
          },
        },
      },
      Vendorfeedback: {
        label: '',
        key: '/Vendorfeedback',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE == 'Vendor' ? VendorChats : ForceLogout,
          },
        },
      },

      market: {
        label: '',
        key: 'market/:propertyId',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: () => {
              const userType = JSON.parse(
                localStorage.getItem('userDetail')
              )?.primaryUserType;

              return userType == 'Buyer' ? <Market /> : <ForceLogout />;
            },
          },
        },
      },

      contact: {
        label: 'Dashboard',
        key: 'people',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE != 'Solicitor' ? ContactPage : ForceLogout,
          },
        },
      },
      Pipeline: {
        label: 'Dashboard',
        key: 'pipeline',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE == 'Agent' ? PipelinePage : ForceLogout,
          },
        },
      },
      ProfileSetting: {
        label: 'ProfileSetting',
        key: 'ProfileSetting',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: ProfileSetting,
          },
        },
      },
      Faq: {
        label: 'Helpcentre',
        key: 'helpcentre',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: Helpdesk,
          },
        },
      },
      insights: {
        label: 'Insights',
        key: 'insights',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component:
              primaryUserType === 'Buyer' ? PageNotFoundFile : Insightpage,
          },
        },
      },

      Invite: {
        label: 'Invite',
        key: 'invite',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: InvitePage,
          },
        },
      },

      BuyerMarketplacePage: {
        label: 'landingpage',
        key: 'landingpage',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE != 'Solicitor' ? LandingPage : ForceLogout,
          },
        },
      },

      Message: {
        label: '',
        key: 'message',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: Message,
          },
          binder: {
            label: '',
            key: 'binder/:binderId',
            exact: true,
            routeType: protectedRoute,
            // component: ViewDashboardDetails,
            component: Message,
            isNavigatable: false,
            showBtn: true,
            showSaveDisabled: true,
          },
          binderwithdetails: {
            label: '',
            key: 'binder/:binderId/buyer/:buyerid/proid/:proid',
            exact: true,
            routeType: protectedRoute,
            // component: ViewDashboardDetails,
            component: Message,
            isNavigatable: false,
            showBtn: true,
            showSaveDisabled: true,
          },
          call: {
            label: '',
            key: 'call/',
            exact: true,
            routeType: protectedRoute,
            // component: ViewDashboardDetails,
            component: Message,
            isNavigatable: false,
            showBtn: true,
            showSaveDisabled: true,
          },
        },
      },

      Savedsearch: {
        label: '',
        key: 'Savedsearch/:searchId',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE != 'Solicitor' ? Savedsearch : ForceLogout,
          },
        },
      },

      TaskPage: {
        label: '',
        key: 'tasks',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component: USER_TYPE != 'Solicitor' ? TaskPage : ForceLogout,
          },
        },
      },

      TaskPageNoteandFeedback: {
        label: '',
        key: 'TaskPageNoteandFeedback',
        routeType: protectedRoute,
        component: RenderRoutesRecursively,
        exact: false,
        routes: {
          '/': {
            label: '',
            key: '/',
            exact: true,
            routeType: protectedRoute,
            component:
              USER_TYPE != 'Solicitor' ? TaskPageNoteandFeedback : ForceLogout,
          },
        },
      },
    },
  },
};

// const routeConfig = {
//   login: {
//   label: "Login",
//   key: "login",
//   component: RenderRoutesRecursively,
//   exact: false,
//   routes: {
//   "/": {
//   label: "",
//   key: "/",
//   exact: true,
//   component: Login,
//   },
//   },
//   },
//   signup: {
//   label: "signup",
//   key: "signup",
//   component: RenderRoutesRecursively,
//   exact: false,
//   routes: {
//   "/": {
//   label: "",
//   key: "/",
//   exact: true,
//   component: SignUp,
//   },
//   },
//   },
//   logout: {
//   label: "Logout",
//   key: "logout",
//   component: RenderRoutesRecursively,
//   exact: false,
//   routes: {
//   "/": {
//   label: "",
//   key: "/",
//   exact: true,
//   component: Logout,
//   },
//   },
//   },
//   "reset-password": {
//   label: "Reset Password",
//   key: "reset-password",
//   component: RenderRoutesRecursively,
//   layout: MainLayoutWithSuspenseBeforeLogin,
//   exact: false,
//   routes: {
//   "/": {
//   label: "",
//   key: "/",
//   exact: true,
//   component: () =><div>reset passwr</div>,
//   },
//   },
//   "/": {
//   label: "/",
//   key: "/",
//   routeType: protectedRoute,
//   component: RenderRoutesRecursively,
//   layout: MainLayoutWithSuspense,
//   exact: false,
//   routes: {
//   dashboard: {
//   label: "Dashboard",
//   key: "dashboard",
//   routeType: protectedRoute,
//   component: RenderRoutesRecursively,
//   exact: false,
//     routes: {
//      "/": {
//   label: "",
//   key: "/",
//   exact: true,
//   routeType: protectedRoute,
//   component: DashBoard,
//   },
//   "view-dashboard": {
//   label: "",
//   key: "view-dashboard/:dashboardId",
//   exact: true,
//   routeType: protectedRoute,
//   component: ViewDashboardDetails,
//   isNavigatable: false,
//   showBtn: true,
//   showSaveDisabled: true,
//   },
//   "property-profile": {
//   label: "",
//   key: "property-profile/:propertyId",
//   exact: true,
//   routeType: protectedRoute,
//   component: PropertyDetailContainer,
//   isNavigatable: false,
//   showBtn: true,
//   showSaveDisabled: true,
//   },
//   },
//   },
//   // "people": {
//   // label: "",
//   // key: "people",
//   // routeType: protectedRoute,
//   // component: ContactPage,
//   // exact: false,
//   // routes: {
//   // "/": {
//   // label: "",
//   // key: "/",
//   // exact: true,
//   // routeType: protectedRoute,
//   // component: ContactPage,
//   // },
//   // },
//   },
//   },
//   },
//   }

export default routeConfig;

MainLayoutWithSuspense.propTypes = {
  children: PropTypes.element.isRequired,
};

MainLayoutWithSuspenseBeforeLogin.propTypes = {
  children: PropTypes.element.isRequired,
};

AdminLayoutWithSuspense.propTypes = {
  children: PropTypes.node.isRequired,
};
